import request from '@/tool/request'
import { encryptData } from '@/api/crypto'

export function fetchShopPackages(params) {
  return request({
    url: '/activity/packages',
    method: 'get',
    params: encryptData(params),
  })
}
